import * as bestWorkplacesPageAction from '../../action_creators/bwi/best_workplaces_page_data_action_creators';
import log from '../../../services/logger_service';
import asyncRecircFeedActions from '../async_recirc_feed_actions';
import get from 'lodash/get';
import asyncFranchiseActions from '../franchise/franchise_page_actions';
import BestWorkplacesPageModel from '../../../models/bwi/best_workplaces_model';

const LATEST_BWI_YEAR = '2022'; // THE MOST RECENT ACTIVE BWI YEAR

function fetchBestWorkplacesPageData(params, store) {
  return BestWorkplacesPageModel.fetch(params, store)
    .then(function handleBestWorkplacesPAgeData(BestWorkplacesPageData) {
      return BestWorkplacesPageData;
    })
    .catch(function handleUserError(err) {
      if (err.message === 'Invalid Year') {
        log.warn(
          'User tried a Best Workplaces For Innovators page with invalid year.'
        );
        // dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
        return false;
      }
      log.warn(
        'Something went wrong loading Best Workplaces For Innovators page.'
      );
      return false;
    });
}

export default function fetchBestWorkplacesPage(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(bestWorkplacesPageAction.bestWorkplacesPageLoading({}, store));

    const { rank } = params;
    const asyncActions = [];
    const isLegacy = 'year' in params;
    if (isLegacy) {
      // Fetch legacy page object
      asyncActions.push(fetchBestWorkplacesPageData(params, store));
    } else {
      const { page } = params;
      // Fetch modern page object
      if (typeof page !== 'undefined') {
        asyncActions.push(
          asyncFranchiseActions(
            { slug: `bwi-${page === 'list' ? LATEST_BWI_YEAR : page}` },
            store
          )(dispatch)
        );
      }
    }
    // Fetch recirc feed
    asyncActions.push(asyncRecircFeedActions(params, store)(dispatch));

    return Promise.all(asyncActions)
      .then(function handlePostDetailData(data) {
        const pageData = get(data, '[0].data', {});
        pageData.initialRank = rank;
        dispatch(
          bestWorkplacesPageAction.bestWorkplacesPageLoaded(pageData, store)
        );
        return true;
      })
      .catch(function handleUserError(err) {
        dispatch(
          bestWorkplacesPageAction.bestWorkplacesPageLoadError(err, store)
        );
        return log.error(
          err,
          `Error in Best Workplaces For Innovators page actions, message: ${
            err.message
          }`
        );
      });
  };
}
